import React from 'react';
import {
  ArticleItem,
  ArticleItems,
  ArticleLink,
  ArticlesContainer,
  ArticlesHeader,
  ArticlesHome,
} from './ArticlesElements';

import { useLanguage } from '../../../hooks';
import { MainPageText } from '../../Library/LibraryMainPage';

const ArticlesSection = () => {
  const { lang } = useLanguage();
  return (
    <>
      <ArticlesHome id="articles">
        <ArticlesContainer>
          <ArticlesHeader>{MainPageText[lang].articles}</ArticlesHeader>

          <ArticleItems>
            <ArticleItem>
              <ArticleLink to="/powerengine">{MainPageText[lang].articles1}</ArticleLink>
            </ArticleItem>
            <ArticleItem>
              <ArticleLink to="/cogeneration">{MainPageText[lang].articles2}</ArticleLink>
            </ArticleItem>
            <ArticleItem>
              <ArticleLink to="/co2">{MainPageText[lang].articles3}</ArticleLink>
            </ArticleItem>
            <ArticleItem>
              <ArticleLink to="/biogas">{MainPageText[lang].articles4}</ArticleLink>
            </ArticleItem>
            <ArticleItem>
              <ArticleLink to="/gas">{MainPageText[lang].articles5}</ArticleLink>
            </ArticleItem>

            <ArticleItem>
              <ArticleLink to="/trigeneration">{MainPageText[lang].articles6}</ArticleLink>
            </ArticleItem>
          </ArticleItems>
        </ArticlesContainer>
      </ArticlesHome>
    </>
  );
};

export default ArticlesSection;
